var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("path",{"id":"a","d":"M28.582 2l5.39 1.444"})),React.createElement("g",{"fill":"none","fillRule":"evenodd","stroke":"#FFF","strokeLinecap":"round","strokeLinejoin":"round","key":1},[React.createElement("path",{"d":"M11.388 5.278H33.3M.842 5.366h4.225M33.68 5.463L29.735 9.41","key":0}),React.createElement("use",{"transform":"rotate(-150 31.582 3)","xlinkHref":"#a","key":1})])]);
}

ArrowRight.defaultProps = {"width":"35","height":"11","viewBox":"0 0 35 11"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
